import { useVideos } from '@bpm-web-app/swr-hooks';
import { useMemo } from 'react';
import { Video, VideoCategory } from '@bpm-web-app/download-api-sdk';
import classNames from 'classnames';
import CardCarousel from '../../shared/card-carousel/card-carousel';
import PrimaryPageTitle from '../../shared/primary-page-title/primary-page-title';
import styles from './videos-per-category.module.css';
import { GhostComponent } from '../../shared';
import { CardCarouselGhostLoading } from '../../shared/card-carousel/card-carousel-ghost-loading';
import { VideoCard } from '../../shared/card/video-card/video-card';

export function VideosPerCategory() {
    const { data: videos, isLoading } = useVideos();

    const videosByCategory: Array<(VideoCategory & { videos: Video[] })> = useMemo(() => {
        const result = videos?.reduce((prevSet, curSet) => {
            const catId = curSet.category?.id;
            const cat = prevSet.find(({ id }) => id === catId);

            if (!cat) {
                const catTitle = curSet.category!.name;
                const catOrder = curSet.category!.order;
                const catSlug = curSet.category!.slug;

                prevSet.push({
                    id: catId,
                    name: catTitle,
                    order: catOrder,
                    slug: catSlug,
                    videos: [curSet],
                });

                return prevSet;
            }

            if (cat.videos.length) {
                cat.videos.push(curSet);
                return prevSet;
            }

            return prevSet;
        }, [] as Array<(VideoCategory & { videos: Video[] })>);
        result?.sort((a, b) => (a.order || 0) - (b.order || 0));
        return result || [];
    }, [videos]);

    const isEverythingLoaded = useMemo(() => {
        if ((!isLoading) && videos) return true;
        return false;
    }, [isLoading, videos]);

    if (!isEverythingLoaded) {
        return (
            <>
                <PrimaryPageTitle title="BPM Academy" />
                <div className="spacing--top" />
                <div className="spacing--top" />

                {[1, 2, 3, 4, 5].map(() => {
                    return (
                        <>
                            <GhostComponent type="secondary-title" />
                            <CardCarouselGhostLoading elementsCount={10} cardSize="small" linesWidthArray={[90, 60]} lineHeight={18} />
                        </>
                    );
                })}
            </>
        );
    }

    return (
        <article className="spacing__window--top">
            <div className={classNames(styles['videos-per-category__heading'], 'spacing__window--horizontal')}>
                <PrimaryPageTitle title="BPM Academy" noPadding />
            </div>
            {videosByCategory.map((data) => (
                (
                    <CardCarousel key={data.slug} title={data.name}>
                        {data.videos.map((set) => (
                            <VideoCard
                                key={set.id}
                                video={set} />
                        ))}
                    </CardCarousel>
                )
            ))}
        </article>
    );
}

export default VideosPerCategory;
